import gql from 'graphql-tag';

const query = gql`
  query DailyTrackerMeal($id: Int!) {
    dailyTracker {
      meal(id: $id) {
        ... on DailyTrackerMealWithProducts {
          id
          name
          calories
          proteinGrams
          carbsGrams
          fatGrams
          portions
          imageUrl
          mealType
          loggedAt
          sourceType
          products {
            id
            name
            brand
            calories
            proteinGrams
            carbsGrams
            fatGrams
            baseAmount
            baseUnit
            measurement {
              measureId
              amount
              text
              unit
            }
          }
        }
      }
    }
  }
`;

export default query;
